export default __webpack_public_path__ + "static/media/abOntimeLogoDS.fb450262.png";